import React, { Fragment, type FunctionComponent } from 'react'
import { spacing, colors, GridCellLoading } from '@retailer-platform/shared-components'
import { InformationIcon } from '@instacart/ids-core'
import styled from '@emotion/styled'
import { useDomainMessages } from 'domains/products/utils/domain/intl'

interface Props {
  loading?: boolean
  error?: boolean
  refetch?: () => void
  errorTitle?: string
}

const ErrorContainer = styled.div({
  display: 'flex',
  justifyItems: 'center',
  color: colors.GRAYSCALE.X30,
  alignItems: 'center',

  svg: {
    fill: colors.GRAYSCALE.X30,
    marginTop: 2,
    marginRight: spacing.X4,
  },
})

export const ProductsSearchTableLazyDataCell: FunctionComponent<Props> = ({
  loading,
  error,
  children,
  refetch,
  errorTitle,
}) => {
  const messages = useDomainMessages({
    error: 'productsDomain.search.failedToLoad',
    notAvailable: 'productsDomain.search.notAvailable',
  })

  if (loading) {
    return <GridCellLoading />
  }

  if (error) {
    return (
      <ErrorContainer
        title={errorTitle || messages.error}
        onClick={() => refetch?.()}
        data-testid="lazy-data-cell-error"
        css={{ cursor: refetch ? 'pointer' : 'default' }}
      >
        <InformationIcon size={15} />
        {messages.notAvailable}
      </ErrorContainer>
    )
  }

  return <Fragment>{children}</Fragment>
}
